import { useEffect } from 'react'
import { isMac } from 'src/lib/osUtils'
import { useRootStore } from 'src/new_arch/providers/RootStoreProvider'

import useUndoableDeleteSystem from '../systems/useUndoableDeleteSystem'

const EDITABLE_TAGS = [ 'INPUT', 'TEXTAREA' ]

const isEditableTarget = () => {
	const element = document.activeElement as HTMLElement | null
	if ( !element ) return false

	return EDITABLE_TAGS.includes( element.tagName ) || element.isContentEditable
}

const hasUndoModifier = ( event: KeyboardEvent ) => ( isMac() ? event.metaKey : event.ctrlKey )

const useUndoDeleteShortcut = () => {
	const undoableDeleteSystem = useUndoableDeleteSystem()
	const { pendingDeletesStore } = useRootStore()

	useEffect( () => {
		const handleKeyDown = ( event: KeyboardEvent ) => {
			if ( event.key.toLowerCase() !== 'z' || event.shiftKey || !hasUndoModifier( event ) ) return
			if ( isEditableTarget() || !pendingDeletesStore.hasUndoable ) return

			event.preventDefault()
			undoableDeleteSystem.undoMostRecent()
		}

		document.addEventListener( 'keydown', handleKeyDown )
		return () => document.removeEventListener( 'keydown', handleKeyDown )
	}, [ undoableDeleteSystem, pendingDeletesStore ] )
}

export default useUndoDeleteShortcut
